import LanguageSelector from '@/components/LanguageSelector';
import { useStandalone } from '@/hook/useStandalone';
import { useSettingsStore } from '@/store/SettingsStore';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  const isStandalone = useStandalone();
  const currentYear = new Date().getFullYear();
  const language = useSettingsStore.getState().language;

  return (
    <footer
      className={`mt-auto w-full py-0 md:py-2 px-2 border-t z-40 bg-background ${isStandalone ? 'pwa-safe-bottom' : ''}`}
    >
      <div className="w-full flex gap-4 items-center justify-center md:justify-end text-sm text-muted-foreground">
        <a
          href="#"
          onClick={() => {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (window as any).__ucCmp.showSecondLayer();
          }}
          rel="noopener noreferrer"
          className="underline text-center"
        >
          {t('footer.privacyPolicySettings')}
        </a>

        <a
          href={`https://mind.com${language && language !== 'en' ? `/${language}` : ''}/resources/company/privacy-policy`}
          target="_blank"
          rel="noopener noreferrer"
          className="underline text-center"
        >
          {t('footer.privacyPolicy')}
        </a>
        <p className="text-center">{t('footer.copyright', { year: currentYear })}</p>
        <LanguageSelector className="sm:hidden" />
      </div>
    </footer>
  );
};

export default Footer;
